import { ReactNode } from "react";

import Card from "ds/components/Card";
import Icon from "ds/components/Icon";
import { GraduationHat } from "components/icons/generated";

import MissionControlMissionsProgressContent from "./Content";

type MissionControlMissionsProgressProps = {
  headerSuffix?: ReactNode;
};

const MissionControlMissionsProgress = ({ headerSuffix }: MissionControlMissionsProgressProps) => (
  <Card
    title="Missions progress"
    headerPrefix={<Icon src={GraduationHat} />}
    headerSuffix={headerSuffix}
  >
    <MissionControlMissionsProgressContent />
  </Card>
);

export default MissionControlMissionsProgress;
